import React from 'react';
import Lottie from 'react-lottie';
import { useScreenSlideIn } from '@/hooks/useScreenSlideIn';
import AixueFooter from '@/components/AixueFooter/index';
import AixueHeader from '@/components/AixueHeader/index';
import styles from './index.module.scss';
import starData from '@/assets/lottie/star-data.json';
import screenBackground from '@/assets/about/about-bg.jpg';
import aboutCommaLeft from '@/assets/about/about-comma-left.png';
import aboutCommaRight from '@/assets/about/about-comma-right.png';
import aboutAbout from '@/assets/about/about-about.png';
import aboutStar from '@/assets/about/about-star.png';
import aboutTeamPic from '@/assets/about/about-team-pic.png';
import aboutVectorLeft from '@/assets/about/about-vector-left.png';
import aboutVectorRight from '@/assets/about/about-vector-right.png';
import aboutGradientBgSmall from '@/assets/about/about-gradient-bg-small.png';
import aboutTeam from '@/assets/about/about-team.png';
import abouCard1 from '@/assets/about/about-small-card-1.png';
import abouCard2 from '@/assets/about/about-small-card-2.png';
import abouCard3 from '@/assets/about/about-small-card-3.png';

const starLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: starData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

export default function AixueAbout() {
  const SCROLL_CONTAINER = '[data-scroll-root="aixue-about"]';
  const teamSectionRef = useScreenSlideIn({
    scrollContainerSelector: SCROLL_CONTAINER,
    triggerSlideRatio: 0.8,
    animationClassName: styles['section-2-team-enter'],
  });

  const section3Ref = useScreenSlideIn({
    scrollContainerSelector: SCROLL_CONTAINER,
    triggerSlideRatio: 0.85,
    animationClassName: styles['section-3-enter'],
  });

  return (
    <div className={styles.container}>
      <div className={styles['about-header']}>
        <AixueHeader title="爱学" />
      </div>
      <div className={styles.contentWrap}>
        <section
          className={styles['section-1']}
          style={{ '--background-1-url': `url(${screenBackground})` } as React.CSSProperties}
        >
          <div className={styles['about-wrap']}>
            <div className={styles['about-content']}>
              <div
                className={`wow animate__animated animate__fadeIn ${styles['about-titleBig']}`}
                style={{ animationDelay: '0.2s', animationDuration: '0.9s' }}
              >
                <div className={styles['about-title-row']}>
                  关于爱学
                  <span className={styles['about-star-wrap']} aria-hidden>
                    <Lottie options={starLottieOptions} />
                  </span>
                </div>
              </div>
              <div
                className={`wow animate__animated animate__fadeIn ${styles['about-desc']}`}
                style={{ animationDelay: '0.4s', animationDuration: '0.9s' }}
              >
                AI学就爱学 · 你的专属AI学习智能体
              </div>
            </div>
          </div>
        </section>

        <section className={styles['section-2']}>
          <div
            className={`${styles['section-2-floating-window']} ${styles['section-2-floating-window-slide-in']}`}
            style={{ animationDelay: '0.5s' }}
          >
            <div className={styles['section-2-floating-title']}>
              <img
                src={aboutCommaLeft}
                alt="section-2-floating-left-comma"
                className={styles['section-2-floating-left-comma']}
              />
              <div className={styles['section-2-floating-title-text']}>
                关于我们
                <img
                  src={aboutAbout}
                  alt="section-2-floating-about"
                  className={styles['section-2-floating-about']}
                />
                <img
                  src={aboutCommaRight}
                  alt="section-2-floating-right-comma"
                  className={styles['section-2-floating-right-comma']}
                />
              </div>
            </div>
            <div className={styles['section-2-floating-content-1']}>
              爱学是北京与爱为舞科技有限公司旗下的AI学习智能体品牌（产品），专注于构建AI原生学习能力。作为一家AI原生应用公司，我们依托自研爱学大模型（国内领先的类真人音视频实时对话式教育大模型）、新一代数字人技术及自研语音大模型，开创性地打造了AI学习智能体这一全新范式，致力于成为该领域的引领者。爱学以“爱与AI帮助每个人成为更好的自己”为品牌使命，旨在为每个人提供一个全时、全知、全能的终身学习AI智能体
              。
            </div>
            <div className={styles['section-2-floating-content-2']}>
              我们打造的AI学习智能体具备三重核心价值：
              <br />
              真人级：毫秒响应、情感理解、多模态融合的类人交互体验；
              <br />
              大师级：沉淀顶尖教育专家方法论，确保专业深度与权威性；
              <br />
              专属级：通过持续互动的长短期记忆与适配，实现终身成长的个性化陪伴。
            </div>
            <img
              src={aboutStar}
              alt="section-2-floating-star"
              className={styles['section-2-floating-star']}
            />
          </div>

          <div
            ref={teamSectionRef.ref as React.RefObject<HTMLDivElement>}
            className={styles['section-2-team-container']}
          >
            <div className={styles['section-2-team-pic-frame']}>
              <img
                src={aboutVectorLeft}
                alt=""
                className={styles['section-2-team-vector-left']}
                aria-hidden
              />
              <img
                src={aboutVectorRight}
                alt=""
                className={styles['section-2-team-vector-right']}
                aria-hidden
              />
              <img
                src={aboutTeamPic}
                alt="section-2-team-pic-img"
                className={styles['section-2-team-pic-img']}
              />
              <img
                src={aboutGradientBgSmall}
                alt=""
                className={styles['section-2-team-gradient-block']}
              />
            </div>
            <div className={styles['section-2-team-txt']}>
              <img
                src={aboutCommaLeft}
                alt="section-2-floating-left-comma-2"
                className={styles['section-2-floating-left-comma']}
              />
              <div className={styles['section-2-team-title']}>
                我们的团队
                <img
                  src={aboutTeam}
                  alt="section-2-floating-team"
                  className={styles['section-2-floating-team']}
                />
              </div>
              <div className={styles['section-2-team-desc']}>
                我们的核心团队汇聚了来自全球企业的杰出人才，他们曾在苹果、字节跳动、拼多多、阿里巴巴、百度、京东、腾讯、快手、高途、猿辅导、好未来、Vipkid、美团、搜狗、滴滴等知名企业担任关键职位。我们的成员不仅拥有来自北京大学、清华大学、中国人民大学、复旦大学、香港理工大学、剑桥大学、卡耐基梅隆大学、新加坡国立大学等世界知名学府的深厚学术背景，还曾荣获
                iF 设计奖、吴文俊人工智能最高奖等荣誉奖项，彰显了他们在各自领域的卓越成就。
              </div>
              <img
                src={aboutCommaRight}
                alt="section-2-floating-right-comma-2"
                className={styles['section-2-floating-right-comma-2']}
              />
            </div>
          </div>
        </section>

        <section
          ref={section3Ref.ref as React.RefObject<HTMLElement>}
          className={styles['section-3']}
        >
          <div className={styles['section-3-title']}>AI学就爱学·你的专属AI学习智能体</div>
          <div className={styles['section-3-cards']}>
            <div className={styles['section-3-card-1']}>
              <img src={abouCard1} alt="" className={styles['section-3-card-img']} />
              <div className={styles['section3-card-title']}>使命</div>
              <div className={styles['section3-card-desc']}>爱与AI帮助每个人成为更好的自己</div>
            </div>
            <div className={styles['section-3-card-2']}>
              <img src={abouCard2} alt="" className={styles['section-3-card-img']} />
              <div className={styles['section3-card-title']}>愿景</div>
              <div className={styles['section3-card-desc']}>成为人人信赖的成长伙伴</div>
            </div>
            <div className={styles['section-3-card-3']}>
              <img src={abouCard3} alt="" className={styles['section-3-card-img']} />
              <div className={styles['section3-card-title']}>价值观</div>
              <div className={styles['section3-card-desc']}>爱自己 爱伙伴 爱世界</div>
            </div>
          </div>
        </section>
      </div>
      <div className={styles['footer-snap']}>
        <AixueFooter />
      </div>
    </div>
  );
}
